import { Navigate, useRoutes } from 'react-router-dom';

import NotFound from './pages/Page404';
import Page401 from './pages/Page401';
import EmpLogin from './pages/EmployeeLogin';
import EditJourney from './components/HrDashboard/pages/journey/EditJourney';
import { RequireAuth } from './utils/RequireAuth';
import ROLES from './utils/Authorization/Roles';
import MeetingVerification from './pages/MeetingVerification';
import EmailLogs from './components/HrDashboard/pages/EmailLogs';
import DashboardLayout from './layouts/dashboard';
import Location from './components/HrDashboard/pages/location/Location';
import AddLocationForm from './components/HrDashboard/pages/location/AddLocationForm';
import CompanyMember from './components/HrDashboard/pages/company-member/CompanyMember';
import AddCompanyMembersForm from './components/HrDashboard/pages/company-member/AddCompanyMemberForm';
import Currency from './components/HrDashboard/pages/currency/Currency';
import AddCurrencyForm from './components/HrDashboard/pages/currency/AddCurrencyForm';
import CompanyType from './components/HrDashboard/pages/company-type/CompanyType';
import AddCompanyType from './components/HrDashboard/pages/company-type/AddCompanyTypeForm';
import ImportHistory from './components/HrDashboard/pages/ImportHistory';
import AddCompany from './components/HrDashboard/pages/company/AddCompany';
import Companies from './components/HrDashboard/pages/company/Companies';
import DndCompanies from './components/HrDashboard/pages/company/DndCompanies';
import AddCMDForm from './components/HrDashboard/pages/cmd/AddCMDForm';
import CMD from './components/HrDashboard/pages/cmd/CMD';
import BulkOutreach from './components/HrDashboard/pages/BulkOutreach';
import SenderDetails from './components/HrDashboard/pages/sender-details/SenderDetails';
import AddSenderDetails from './components/HrDashboard/pages/sender-details/AddSenderDetails';
import Practice from './components/HrDashboard/pages/practice/Practice';
import AddPracticeForm from './components/HrDashboard/pages/practice/AddPracticeForm';
import MasterData from './components/HrDashboard/pages/master-data/MasterData';
import ConfidenceLevel from './components/HrDashboard/pages/confidence-level/ConfidenceLevel';
import AddConfidenceLevelForm from './components/HrDashboard/pages/confidence-level/AddConfidenceLevelForm';
import AddIndustryForm from './components/HrDashboard/pages/industry/AddIndustryForm';
import Industry from './components/HrDashboard/pages/industry/Industry';
import Dashboard from './components/HrDashboard/pages/dashboard/Dashboard'; 
import Users from './components/HrDashboard/pages/users/Users';
import Partners from './components/HrDashboard/pages/users/Partners';
import AddUserForm from './components/HrDashboard/pages/users/AddUser';
import Teams from './components/HrDashboard/pages/teams/Teams';
import Templates from './components/HrDashboard/pages/templates/Templates';
import PromptLibrary from './components/HrDashboard/pages/prompt-library/PromptLibrary';
import EnrichmentProgress from './components/HrDashboard/pages/prompt-library/EnrichmentProgress';
import Learning from './components/HrDashboard/pages/learning/Learning';
import Tutorials from './components/HrDashboard/pages/tutorials/Tutorials';
import SharedVideos from './components/HrDashboard/pages/sharedVideos/SharedVideos';
import SharedVideoPublic from './pages/SharedVideoPublic';
import Page403 from './pages/Page403';
import PerformanceScorecard from './components/HrDashboard/pages/performance/PerformanceScorecard';
import CommandCenter from './components/HrDashboard/pages/command-center/CommandCenter';
import Tasks from './components/HrDashboard/pages/tasks/Tasks';
import { SupportTickets } from './components/HrDashboard/pages/SupportTickets';
import Invoicing from './components/HrDashboard/pages/invoicing/Invoicing';
import NotificationSettingsPage from './pages/settings/NotificationSettingsPage';
import OutlookEmailPage from './components/HrDashboard/pages/outlook/OutlookEmailPage';
import OutlookCalendarPage from './components/HrDashboard/pages/outlook/OutlookCalendarPage';
import InvestorRegister from './pages/investor/InvestorRegister';
import InvestorLogin from './pages/investor/InvestorLogin';
import InvestorVerifyEmail from './pages/investor/InvestorVerifyEmail';
import InvestorSetup2FA from './pages/investor/InvestorSetup2FA';
import InvestorForgotPassword from './pages/investor/InvestorForgotPassword';
import InvestorResetPassword from './pages/investor/InvestorResetPassword';
import InvestorSetPassword from './pages/investor/InvestorSetPassword';
import InvestorDashboard from './pages/investor/InvestorDashboard';
import InvestorPendingApproval from './pages/investor/InvestorPendingApproval';
import InvestorResendVerification from './pages/investor/InvestorResendVerification';
import InvestorTerms from './pages/investor/InvestorTerms';
import InvestorPrivacy from './pages/investor/InvestorPrivacy';
import InvestorProfile from './pages/investor/InvestorProfile';
import InvestorSettings from './pages/investor/InvestorSettings';
import AdminInvestorList from './components/HrDashboard/pages/syndication/AdminInvestorList';
import AdminDealList from './components/HrDashboard/pages/syndication/AdminDealList';
// Phase 3: Investor Layout + Deal pages
import InvestorLayout from './layouts/InvestorLayout';
import InvestorDealList from './pages/investor/InvestorDealList';
import InvestorDealRoom from './pages/investor/InvestorDealRoom';
import InvestorPortfolio from './pages/investor/InvestorPortfolio';
// Phase 3: Founder pages
import FounderLayout from './layouts/FounderLayout';
import FounderLogin from './pages/founder/FounderLogin';
import FounderSetPassword from './pages/founder/FounderSetPassword';
import FounderSetup2FA from './pages/founder/FounderSetup2FA';
import FounderDealList from './pages/founder/FounderDealList';
import FounderDealRoom from './pages/founder/FounderDealRoom';
import FounderProfile from './pages/founder/FounderProfile';
import AdminFounderList from './components/HrDashboard/pages/syndication/AdminFounderList';
import AdminAnalytics from './components/HrDashboard/pages/syndication/AdminAnalytics';
import AdminSettings from './components/HrDashboard/pages/syndication/AdminSettings';
// ---------- Outreach (Phase 1 demo) ----------
import CampaignList from './components/Outreach/CampaignList';
import CampaignCreatorV2 from './components/Outreach/CampaignCreatorV2';
import CampaignEditForm from './components/Outreach/CampaignEditForm';
import CampaignDetail from './components/Outreach/CampaignDetail';
import CampaignOverview from './components/Outreach/CampaignOverview';
import CampaignQueue from './components/Outreach/CampaignQueue';
import LiveMonitor from './components/Outreach/LiveMonitor';
import ConnectedAccounts from './components/Outreach/ConnectedAccounts';
import Segments from './components/Outreach/Segments';
import MessageTemplates from './components/Outreach/MessageTemplates';
import MyOutreachHome from './components/MyOutreach/MyOutreachHome';
import SignaturePage from './components/Outreach/SignaturePage';
import MyReviewQueue from './components/MyOutreach/MyReviewQueue';
import CompanyTimeline from './components/MyOutreach/CompanyTimeline';
// ----------------------------------------------------------------------


export default function Router() {

  return useRoutes([


    // -------- PUBLIC ROUTES --------
    {
      path: '/',
      children: [
        { path: 'login', element: <EmpLogin /> },
        { path: 'meeting/:token', element: <MeetingVerification /> },
        { path: 'shared-video/:token', element: <SharedVideoPublic /> },

        // ---------- Investor Public Routes ----------
        { path: 'investor/register', element: <InvestorRegister /> },
        { path: 'investor/login', element: <InvestorLogin /> },
        { path: 'investor/verify-email/:token', element: <InvestorVerifyEmail /> },
        { path: 'investor/setup-2fa', element: <InvestorSetup2FA /> },
        { path: 'investor/forgot-password', element: <InvestorForgotPassword /> },
        { path: 'investor/reset-password/:token', element: <InvestorResetPassword /> },
        { path: 'investor/set-password/:token', element: <InvestorSetPassword /> },
        { path: 'investor/pending', element: <InvestorPendingApproval /> },
        { path: 'investor/resend-verification', element: <InvestorResendVerification /> },
        { path: 'investor/terms', element: <InvestorTerms /> },
        { path: 'investor/privacy', element: <InvestorPrivacy /> },

        // ---------- Founder Public Routes ----------
        { path: 'founder/login', element: <FounderLogin /> },
        { path: 'founder/set-password/:token', element: <FounderSetPassword /> },
        { path: 'founder/setup-2fa', element: <FounderSetup2FA /> },

        { path: '404', element: <NotFound /> },
        { path: '403', element: <Page403 />},
        { path: '401', element: <Page401 /> },
        { path: '/', element: <Navigate to="/login" /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    { path: '*', element: <Navigate to="/404" /> },

    // -------- INVESTOR PROTECTED ROUTES (InvestorLayout with sidebar) --------
    {
      path: '/investor',
      element: <RequireAuth allowedRoles={[ROLES.INVESTOR]}><InvestorLayout /></RequireAuth>,
      children: [
        { path: 'dashboard', element: <InvestorDashboard /> },
        { path: 'deals', element: <InvestorDealList /> },
        { path: 'deals/:dealCode', element: <InvestorDealRoom /> },
        { path: 'portfolio', element: <InvestorPortfolio /> },
        { path: 'profile', element: <InvestorProfile /> },
        { path: 'settings', element: <InvestorSettings /> },
      ],
    },

    // -------- FOUNDER PROTECTED ROUTES (FounderLayout with sidebar) --------
    {
      path: '/founder',
      element: <RequireAuth allowedRoles={[ROLES.FOUNDER]}><FounderLayout /></RequireAuth>,
      children: [
        { path: 'deals', element: <FounderDealList /> },
        { path: 'deals/:dealCode', element: <FounderDealRoom /> },
        { path: 'profile', element: <FounderProfile /> },
      ],
    },

    // -------- PROTECTED ROUTES --------
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { path: 'gwx', element: <Navigate to="/dashboard" /> },
        { path: 'companies', element: <Companies /> },
        { path: 'dnd-companies', element: <DndCompanies /> },
        { path: 'companies/add/', element: <AddCompany /> },
        { path: 'companies/:id', element: <EditJourney /> },
        { path: 'dashboard/', element: <Dashboard /> },

        {
          path: 'users', element: <Users />
        },
        {
          path: 'partners', element: <Partners />
        },
        {
          path: 'users/add', element: <AddUserForm />
        },
        { path: 'users/edit/:id', element:  <AddUserForm /> },

        // ----------- Email Logs -----------
        {
          path: 'email-logs', element: <RequireAuth
            allowedRoles={[ROLES.FSD_Admin]} permissions={['can_view_email_logs']} > <EmailLogs /> </RequireAuth>,
        },

        // ---------- Location ----------

        {
          path: 'location', element: <Location />
        },
        {
          path: 'location/add', element: <AddLocationForm />
        },
        { path: 'location/edit/:id', element:  <AddLocationForm /> },

        // ---------- Practice ----------

        {
          path: 'practice', element: <Practice />
        },
        {
          path: 'practice/add', element: <AddPracticeForm />
        },
        { path: 'practice/edit/:id', element:  <AddPracticeForm /> },

        // ---------- Master Data (SUPER_ADMIN cascading 4-level hierarchy, A1 FR-010) ----------
        {
          path: 'master-data',
          element: <RequireAuth allowedRoles={[ROLES.SUPER_ADMIN]}><MasterData /></RequireAuth>
        },

        // ---------- Currency ----------

        {
          path: 'currency', element: <Currency />
        },
        {
          path: 'currency/add', element: <AddCurrencyForm />
        },
        { path: 'currency/edit/:id', element:  <AddCurrencyForm /> },

        // ---------- CMD ----------

        {
          path: 'cmd', element: <CMD />
        },
        {
          path: 'cmd/add', element: <AddCMDForm />
        },
        { path: 'cmd/edit/:id', element:  <AddCMDForm /> },

        // ---------- Company Member ----------

        {
          path: 'company-members', element: <CompanyMember />
        },
        {
          path: 'company-members/add', element: <AddCompanyMembersForm />
        },
        // ---------- Company Type ----------

        {
          path: 'company-type', element: <CompanyType />
        },
        {
          path: 'company-type/add', element: <AddCompanyType />
        },
        { path: 'company-type/edit/:id', element:  <AddCompanyType /> },
        {
          path: 'confidence-level', element: <ConfidenceLevel />
        },
        {
          path: 'confidence-level/add', element: <AddConfidenceLevelForm />
        },        
        { path: 'confidence-level/edit/:id', element:  <AddConfidenceLevelForm /> },
        {
          path: 'industry', element: <Industry />
        },
        {
          path: 'industry/add', element: <AddIndustryForm />
        },        
        { path: 'industry/edit/:id', element:  <AddIndustryForm /> },
        // ---------- Import History ----------
        { path: 'excel-import', element: <ImportHistory/>},
        
        // ---------- Bulk Outreach History ----------
        { path: 'bulk-outreach', element: <BulkOutreach/>},

        // ---------- Teams ----------
        { path: 'teams', element: <Teams/>},

        // ---------- Templates ----------
        { path: 'templates', element: <Templates/>},

        // ---------- Prompt Library ----------
        { path: 'prompt-library', element: <PromptLibrary /> },
        { path: 'enrichment-progress/:runHistoryId', element: <EnrichmentProgress /> },

        // ---------- Learning ----------
        { path: 'learning', element: <Learning /> },

        // ---------- Tutorials ----------
        { path: 'tutorials', element: <Tutorials /> },

        // ---------- Shared Videos ----------
        { path: 'shared-videos', element: <SharedVideos /> },

        // ---------- Tasks ----------
        { path: 'tasks', element: <Tasks/>},

        // ---------- Invoicing (B2, ungated — Global Constraint 10) ----------
        { path: 'invoicing', element: <Invoicing /> },

        // ---------- Company Member ----------

        {
          path: 'sender-details', element: <SenderDetails />
        },
        {
          path: 'sender-details/add', element: <AddSenderDetails />
        },
        { path: 'sender-details/edit/:id', element:  <AddSenderDetails /> },

        // ---------- Performance Scorecard ----------
        { path: 'performance', element: <PerformanceScorecard /> },

        // ---------- Command Center (SUPER_ADMIN executive analytics) ----------
        { path: 'command-center', element: <RequireAuth allowedRoles={[ROLES.SUPER_ADMIN]}><CommandCenter /></RequireAuth> },
        {
          path: 'support', title: 'Feedbacks', element:  <SupportTickets />
        },

        // ---------- Notification Settings ----------
        { path: 'settings/notifications', element: <NotificationSettingsPage /> },

        // ---------- Outlook Email ----------
        { path: 'outlook-email', element: <OutlookEmailPage /> },

        // ---------- Outlook Calendar ----------
        { path: 'outlook-calendar', element: <OutlookCalendarPage /> },

        // ---------- Outreach (Phase 1 demo) ----------
        { path: 'outreach/campaigns',               element: <CampaignList /> },
        { path: 'outreach/campaigns/new',           element: <CampaignCreatorV2 /> },
        { path: 'outreach/campaigns/:id/edit',      element: <CampaignEditForm /> },
        { path: 'outreach/campaigns/:id/queue',         element: <CampaignQueue /> },
        { path: 'outreach/campaigns/:id/conversations', element: <CampaignDetail /> },
        { path: 'outreach/campaigns/:id',               element: <CampaignOverview /> },
        { path: 'outreach/monitor',           element: <LiveMonitor /> },
        { path: 'outreach/accounts',          element: <ConnectedAccounts /> },
        { path: 'outreach/segments',          element: <Segments /> },
        { path: 'outreach/templates',         element: <MessageTemplates /> },
        { path: 'my-outreach',                element: <MyOutreachHome /> },
        { path: 'my-outreach/review',         element: <MyReviewQueue /> },
        { path: 'my-outreach/company/:id',    element: <CompanyTimeline /> },
        { path: 'signature',                  element: <SignaturePage /> },

        // ---------- Syndication Admin ----------
        { path: 'syndication/investors', element: <RequireAuth allowedRoles={[ROLES.SUPER_ADMIN]}><AdminInvestorList /></RequireAuth> },
        { path: 'syndication/deals', element: <RequireAuth allowedRoles={[ROLES.SUPER_ADMIN]}><AdminDealList /></RequireAuth> },
        { path: 'syndication/founders', element: <RequireAuth allowedRoles={[ROLES.SUPER_ADMIN]}><AdminFounderList /></RequireAuth> },
        { path: 'syndication/analytics', element: <RequireAuth allowedRoles={[ROLES.SUPER_ADMIN]}><AdminAnalytics /></RequireAuth> },
        { path: 'syndication/settings', element: <RequireAuth allowedRoles={[ROLES.SUPER_ADMIN]}><AdminSettings /></RequireAuth> }
      ]
    },
  ]);
}
